<script setup lang="ts">
  import LinkIcon from '@/shared/assets/icons/LinkIcon.svg';
  import UploadIcon from '@/shared/assets/icons/UploadIcon.svg';
  import UploadTipsHeader from './tips/UploadTipsHeader.vue';
  import UploadMethodCard from './tips/UploadMethodCard.vue';

  interface Requirement {
    text: string;
    emphasized?: string;
    hasLineBreak?: boolean;
  }

  const uploadRequirements: Requirement[] = [
    {
      text: 'Arquivos podem ter as extensões:',
      emphasized: '.pdf | .docx | .txt | .pptx | .xlsx | .xlsm',
      hasLineBreak: true,
    },
    {
      text: 'O formato obrigatório para o título do arquivo deve conter:',
      emphasized: '[Prefixo]+[Numeração]+.[Sequencial].extensão',
      hasLineBreak: true,
    },
  ];

  const urlRequirements: Requirement[] = [
    {
      text: 'A URL deve seguir a mesma fórmula de título dos demais documentos, porém sem a extensão, e é preenchida abaixo da URL.',
      emphasized: '[Prefixo]+[Numeração]+.[Sequencial]',
      hasLineBreak: true,
    },
    {
      text: 'O nome do documento é adicionado posteriormente, na configuração do documento.',
      hasLineBreak: true,
    },
  ];
</script>

<template>
  <div
    id="tip-wrapper"
    class="flex flex-col gap-3 border border-gray-03 rounded-xl p-5 bg-gray-14"
  >
    <!-- Top part -->
    <UploadTipsHeader />

    <!-- Bottom part -->
    <div class="flex gap-6 mt-0 w-full">
      <UploadMethodCard
        :icon="UploadIcon"
        title="Upload"
        :requirements="uploadRequirements"
        example="Exemplo: DA05.2.pdf"
      />
      <UploadMethodCard
        :icon="LinkIcon"
        title="URL"
        :requirements="urlRequirements"
      />
    </div>
  </div>
</template>
